import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Button, CircularProgress, Snackbar } from '@mui/material';

import BookingsActions from '@/actions/BookingsActions';
import BookingsConstants from '@/constants/BookingsConstants';
import { RESERVATION_STATUS } from '@arbitrip/constants/reservations';
import Validator from 'arbitrip-common/client/utils/Validator';

const BookingDrawerTasId = ({ sync_combtas_status, booking, is_agent_or_tm }) => {
	const { t } = useTranslation();
	const [tasId, setTasId] = useState(booking?.combtas_id || '');
	const [showEditButton, setShowEditButton] = useState(!!booking?.combtas_id);
	const [isEditing, setIsEditing] = useState(false);
	const [syncStatus, setSyncStatus] = useState(sync_combtas_status);
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [showValidationError, setShowValidationError] = useState(false);

	useEffect(() => {
		setSyncStatus(sync_combtas_status);
	}, [sync_combtas_status]);

	useEffect(() => {
		if (syncStatus === BookingsConstants.STATUS.SUCCESS || syncStatus === BookingsConstants.STATUS.FAILED) {
			setOpenSnackbar(true);
		}

		if (syncStatus === BookingsConstants.STATUS.SUCCESS) {
			setShowEditButton(true);
			setIsEditing(false);
		}
	}, [syncStatus]);

	const handleSync = () => {
		if (Validator.validateCombtasId(tasId)) {
			BookingsActions.syncCombtas(booking.id, tasId);
		} else {
			setShowValidationError(true);
		}
	};

	const handleTasChange = (e) => {
		setTasId(e.target.value.replace(/\s/g, '').toUpperCase());
		setShowValidationError(false);
	};

	const isLoading = syncStatus === BookingsConstants.STATUS.BUSY;
	const inputDisabled = isLoading || !is_agent_or_tm || (showEditButton && !isEditing);
	const buttonDisabled = isLoading || !is_agent_or_tm;
	const showActionButton = _.get(booking, 'status', '') !== RESERVATION_STATUS.CANCELLED;
	
	return (
		<div className={'booking-field'}>
			<div className="field-row">
				<div className="field-title">{t('SyncToCombtas')}</div>
			</div>
			<div className="field-description">{t('AddYourTasId')}</div>
			<div className="tas-id">
				<TextField
					fullWidth
					size="small"
					value={tasId}
					onChange={(e) => handleTasChange(e)}
					disabled={inputDisabled}
					placeholder={t('TASIDPlaceholder')}
				/>
				{is_agent_or_tm && showActionButton && (
					<Button
						variant={showEditButton ? 'outlined' : ''}
						className={`sync-tas-button ${!tasId ? 'disabled' : ''} ${showEditButton ? 'edit' : 'sync'}`}
						disabled={buttonDisabled}
						onClick={() => {
							if (!tasId) return;

							if (!showEditButton) {
								handleSync();
							} else {
								setShowEditButton(false);
								setIsEditing(true);
							}
						}}
					>
						{isLoading ? <CircularProgress size={16} /> : showEditButton ? t('Edit') : t('Sync')}
					</Button>
				)}
			</div>
			{showValidationError && <div className="tas-id-error">{t('ProvideValidTasId')}</div>}
			<Snackbar
				open={openSnackbar}
				autoHideDuration={3000}
				onClose={() => {
					setOpenSnackbar(false);
					BookingsActions.resetSyncCombtasStatus();
				}}
				message={
					syncStatus === BookingsConstants.STATUS.SUCCESS
						? t('TasIdSyncedSuccesfully')
						: syncStatus === BookingsConstants.STATUS.FAILED
							? t('TasIdSyncFailed')
							: ''
				}
			/>
		</div>
	);
};

export default BookingDrawerTasId;
